<template>
  <f-dashboard-content-layout>
    <template #dashboard-content-side>
      <f-dashboard-content-nav
        v-for="listNav in listNavs"
        :key="listNav.title"
        :links="listNav.links"
      >
        <template #title>
          <h6>
            <i :class="listNav.icon"></i>
            <small>{{ listNav.title }}</small>
          </h6>
        </template>
      </f-dashboard-content-nav>
    </template>

    <router-view></router-view>
  </f-dashboard-content-layout>
</template>

<script>
  import { computed } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import useRoles from '@composables/use-roles'
  import router from '@core/router'

  export default {
    setup() {
      const { get } = useStore('@freebe/codes')
      const { checkPermissions } = useRoles()

      if (!checkPermissions('freebe/pricing/codes:find')) {
        router.replace({ name: 'home' })
      }

      const codeId = computed(() => 
        router.currentRoute.value.params.id
      )
      
      const code = computed(() =>
        get(codeId.value)
      )

      const listNavs = computed(() => [{
        title: 'Réductions',
        icon: 'uil uil-pricetag-alt',
        links: [
          {
            name: 'Codes',
            to: {
              name: 'codes-list'
            },
            exact: true
          }
        ]
      }])

      return {
        listNavs
      }
    }
  }
</script>
